(function(MapFacilitiesPartial) {
    'use strict';

    var Way2web = window.Way2web || {};

    MapFacilitiesPartial.renderMap = function($el) {
        var $markers = $el.find('.marker');
        var args = {
            zoom: 16,
            center: new google.maps.LatLng(0, 0),
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            styles: Way2web.MapShared.style,
            scrollwheel: false,
            draggable: true,

            disableDefaultUI: true,
            zoomControl: false
        };

        // prevent dragging on palm
        if (!verge.mq(Way2web.config.breakpoints.desk)) {
            args.draggable = false;
        }

        // create map
        var map = new google.maps.Map($el[0], args);

        // add a markers reference
        map.markers = [];

        // add markers
        $markers.each(function() {
            MapFacilitiesPartial.addMarker($(this), map);
        });

        // center map
        MapFacilitiesPartial.centerMap(map);
    };

    MapFacilitiesPartial.addMarker = function($marker, map) {
        var canvas = document.createElement('canvas');
        canvas.width = 200;
        canvas.height = 200;
        var context = canvas.getContext('2d');

        var centerX = 50;
        var centerY = 50;
        var radius = 25;

        context.beginPath();
        context.arc(centerX, centerY, radius, 0, 2 * Math.PI, false);
        context.fillStyle = 'rgb(196, 35, 42)';
        context.fill();
        context.lineWidth = 10;
        context.strokeStyle = 'rgba(196, 35, 42, .5)';
        context.stroke();

        context.font = '22px Arial';
        context.fillStyle = '#ffffff';
        context.fillText($marker.attr('data-nr'), 30, 58);
        context.textAlign = 'center';

        var image = {
            url: canvas.toDataURL(),
            size: new google.maps.Size(80, 104),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(40, 104)
        };

        var shape = {
            coords: [1, 1, 1, 104, 80, 104, 80, 1],
            type: 'poly'
        };

        var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));

        if ($marker.attr('data-icon') !== '') {
            image = $marker.attr('data-icon');
        }

        var marker = new google.maps.Marker({
            position: latlng,
            icon: image,
            shape: shape,
            map: map,
            id: $marker.attr('data-id')
        });

        // add to array
        map.markers.push(marker);
    };

    MapFacilitiesPartial.centerMap = function(map) {
        var bounds = new google.maps.LatLngBounds();

        // loop through all markers and create bounds
        $.each(map.markers, function(i, marker) {
            var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
            bounds.extend(latlng);
        });

        if (map.markers.length == 1) {
            // set center of map
            map.setCenter(bounds.getCenter());
            map.setZoom(16);
        } else {
            // fit to bounds
            map.fitBounds(bounds);
        }
    };

    MapFacilitiesPartial.init = function() {
        $('.js-facilities-partial').each(function() {
            MapFacilitiesPartial.renderMap($(this));
        });
    };

})(window.Way2web.MapFacilitiesPartial = window.Way2web.MapFacilitiesPartial || {});
